import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const [email, setEmail] = useState('');
  const { t } = useTranslation('common');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <footer className="bg-[#0f1419] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-12">
          <div>
            <div className="text-3xl font-bold mb-2">
              INSIDE <span className="text-[#14B8A6]">Global</span>
            </div>
            <p className="text-gray-400 text-sm">{t('footer.tagline')}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <h4 className="text-white text-base font-bold mb-4">{t('footer.about.title')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.about.overview')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.about.management')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.about.history')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.about.careers')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-base font-bold mb-4">{t('footer.services.title')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.services.research')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.services.matching')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.services.legal')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.services.marketing')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-base font-bold mb-4">{t('footer.partnership.title')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.partnership.cases')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.partnership.network')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.partnership.inquiry')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.partnership.benefits')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-base font-bold mb-4">{t('footer.support.title')}</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.support.faq')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.support.contact')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.support.terms')}
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.support.privacy')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center mb-12 pb-12 border-b border-gray-800">
          <div className="rounded-2xl overflow-hidden w-full h-48">
            <img
              src="https://public.readdy.ai/ai/img_res/4bf892c0ead873888fe36f05bb744fad.jpg"
              alt="Global Office"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="lg:pl-8">
            <h3 className="text-white text-2xl font-serif leading-relaxed whitespace-pre-line">
              {t('footer.newsletter.title')}
            </h3>
          </div>

          <div>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed whitespace-pre-line">
              {t('footer.newsletter.subtitle')}
            </p>
            <form onSubmit={handleSubmit} className="flex space-x-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('footer.newsletter.placeholder')}
                className="flex-1 bg-transparent border border-gray-700 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#14B8A6] transition-colors"
                required
              />
              <button
                type="submit"
                className="bg-[#14B8A6] text-white px-6 py-3 rounded-lg hover:bg-[#0d9488] transition-all flex items-center justify-center w-12 h-12 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-gray-400 text-sm">
              {t('footer.copyright')}
            </p>
          </div>

          <div className="flex items-center space-x-6">
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 text-sm hover:text-[#14B8A6] transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('footer.poweredBy')}
            </a>
            <a href="#" className="text-gray-400 hover:text-[#14B8A6] transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-xl w-6 h-6 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-[#14B8A6] transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-xl w-6 h-6 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-[#14B8A6] transition-colors cursor-pointer">
              <i className="ri-twitter-x-fill text-xl w-6 h-6 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-[#14B8A6] transition-colors cursor-pointer">
              <i className="ri-instagram-fill text-xl w-6 h-6 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
